namespace Nobox.Nobox.Pages {
    export interface SendFormResponse {
        IsError?: boolean;
        ErrMsg?: string;
        Data?: any;
    }
}
